import Transform from '@ember-data/serializer/transform';
import Money from '@square/dashboard-money/models/money';

// eslint-disable-next-line ember/no-classic-classes
export default Transform.extend({
  deserialize(proto) {
    if (proto !== null && proto !== undefined) {
      return Money.fromCents(proto.amount, proto.currency_code);
    } else {
      return undefined;
    }
  },
  serialize(money) {
    if (money !== null && money !== undefined) {
      return {
        amount: money.amount,
        currency_code: money.currencyCode
      };
    } else {
      return undefined;
    }
  }
});